<template>
  <div>
    <div v-if="version == 1">
      <div class="careerMajorList" v-if="careerData">
        <div class="mainBox">
          目标职业领域：
          <el-select
            v-model="careerMajorObj.targetCareerField"
            placeholder="请选择目标职业领域"
            style="width: 308px"
            @change="changeFiled"
          >
            <el-option
              v-for="(item, index) in careerData"
              :label="item.name"
              :value="item.name"
              :key="index"
            ></el-option>
          </el-select>
        </div>
        <div class="mainBox">
          <p>目标职业：</p>
          <el-checkbox-group v-model="careerMajorObj.targetCareer" :max="3">
            <el-row>
              <el-col
                :span="8"
                v-for="(item, index) in careerData[
                  careerMajorObj.careerDataIndex
                ].occupation"
                :key="index"
              >
                <el-checkbox :label="item.name"></el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </div>
        <div class="mainBox">
          <p>目标专业：</p>
          <el-checkbox-group v-model="careerMajorObj.targetSubject" :max="3">
            <el-row>
              <el-col
                :span="8"
                v-for="(item, index) in careerData[
                  careerMajorObj.careerDataIndex
                ].major"
                :key="index"
              >
                <el-checkbox :label="item.name"></el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </div>
        <div class="summary">
          <SummaryTitle title="咨询记录" />
          <el-input
            class="area"
            type="textarea"
            v-model="careerMajorObj.targetRemark"
            rows="5"
            maxLength="500"
          ></el-input>
        </div>
      </div>
    </div>

    <div v-if="version == 2">
        <div class="careerMajorList">
          <div class="mainBox">
            目标专业类：
            <el-select
              v-model="selectDataNumberZhuanye"
              @change="selectChangeZhuanye"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, key) in careerMajorsZhuanye"
                :key="item.name"
                :label="item.name"
                :value="key"
              >
              </el-option>
            </el-select>
          </div>
          <div class="mainBox">
            <el-row>
              <el-col
                :span="8"
                v-for="(item, key) in tuijianDataZhuanye || []"
                :label="item.name || item.three"
                :key="key"
              >
                <el-checkbox-group v-model="careerMajorObj.targetSubject" :max="3">
                  <el-checkbox  :label="item.name||item.three">{{ item.name || item.three }}</el-checkbox>
                </el-checkbox-group>
              </el-col>
            </el-row>
          </div>
          <div  class="mainBox">
            目标职业类：
            <el-select
              v-model="selectDataNumberZhiye"
              @change="selectChangeZhiye"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, key) in careerMajorsZhiye"
                :key="item.name"
                :label="item.name"
                :value="key"
              >
              </el-option>
            </el-select>
          </div>
          <div  class="mainBox">
            <el-row>
              <el-col
                :span="8"
                v-for="(item, key) in tuijianDataZhiye || []"
                :label="item.name || item.two"
                :key="key"
              >
                <el-checkbox-group v-model="careerMajorObj.targetCareer" :max="3">
                  <el-checkbox :label="item.name||item.two">{{ item.name || item.two }}</el-checkbox>
                </el-checkbox-group>
              </el-col>
            </el-row>
          </div>
          <div class="summary">
          <SummaryTitle title="咨询记录" />
          <el-input
            class="area"
            type="textarea"
            v-model="careerMajorObj.targetRemark"
            rows="5"
            maxLength="500"
          ></el-input>
        </div>
        </div>       
    </div>
    <div v-if="version == ''">
        <div class="careerMajorList">
          <div class="mainBox">
            目标专业类：
            <el-select
              v-model="selectDataNumberZhuanye"
              @change="selectChangeZhuanye"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, key) in careerMajorsZhuanye"
                :key="item.name"
                :label="item.name"
                :value="key"
              >
              </el-option>
            </el-select>
          </div>
          <div class="mainBox">
            <el-row>
              <el-col
                :span="8"
                v-for="(item, key) in tuijianDataZhuanye || []"
                :label="item.name || item.three"
                :key="key"
              >
                <el-checkbox-group v-model="careerMajorObj.targetSubject" :max="3">
                  <el-checkbox  :label="item.name||item.three">{{ item.name || item.three }}</el-checkbox>
                </el-checkbox-group>
              </el-col>
            </el-row>
          </div>
          <div  class="mainBox">
            目标职业类：
            <el-select
              v-model="selectDataNumberZhiye"
              @change="selectChangeZhiye"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, key) in careerMajorsZhiye"
                :key="item.name"
                :label="item.name"
                :value="key"
              >
              </el-option>
            </el-select>
          </div>
          <div  class="mainBox">
            <el-row>
              <el-col
                :span="8"
                v-for="(item, key) in tuijianDataZhiye || []"
                :label="item.name || item.two"
                :key="key"
              >
                <el-checkbox-group v-model="careerMajorObj.targetCareer" :max="3">
                  <el-checkbox :label="item.name||item.two">{{ item.name || item.two }}</el-checkbox>
                </el-checkbox-group>
              </el-col>
            </el-row>
          </div>
          <div class="summary">
          <SummaryTitle title="咨询记录" />
          <el-input
            class="area"
            type="textarea"
            v-model="careerMajorObj.targetRemark"
            rows="5"
            maxLength="500"
          ></el-input>
        </div>
        </div>       
    </div>
  </div>
</template>
<script>
// import API from '@/api/index.js';
import SummaryTitle from "./SummaryTitle.vue";
export default {
  name: "careerMajorList",
  props: ["careerMajorObj"],
  components: {
    SummaryTitle,
  },
  data() {
    return {
      careerData: null,
      version: "2",
      reportId: "",
      selectDataNumberZhuanye: "",
      careerMajorsZhuanye: [],
      // targetCareerZhuanye: [],
      tuijianDataZhuanye: [],

      selectDataNumberZhiye: "",
      careerMajorsZhiye: [],
      careerRecommend: [],
      // targetCareerZhiye: [],
      tuijianDataZhiye: [],
      // careerDataIndex: 0,
      // c_targetCareerField: this.targetCareerField,//目标职业领域
      // c_targetCareer: this.targetCareer,//目标职业
      // c_targetSubject: this.targetSubject,//目标专业
      // c_targetRemark: this.targetRemark,//咨询记录
    };
  },

  computed: {
    
  },
  watch: {},
  methods: {
    // 获取生涯测评职业领域、目标职业、目标专业
    judgeNewOld(){
      this.$ajax.post(this.G_acapi + this.ports.consultant.student.report.judge,{
        studentId:window.sessionStorage.getItem('myStudentStudentId')||this.componentId
      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res=>{
        if(res.data.code==2000){
           
          this.version=res.data.data.career.version;
        
          
        }else{
        }
      })
    },
    getCareerMajor() {
      this.$ajax
        .post(
          this.G_acapi +
            this.ports.consultant.student.mine.planningContent.getCareerMajor,
          {},
          {
            headers: {
              token: window.sessionStorage.getItem("ymtxToken"),
            },
          }
        )
        .then((res) => {
          if (res.data.code == 2000) {
            this.careerData = res.data.data;
          } else {
          }
        });
    },
    getReportData(id) {
      this.$ajax
        .post(
          this.G_capi + this.ports.consultant.student.report.newReportData,
          {
            reportId: id,
          },
          {
            headers: {
              token: window.sessionStorage.getItem("ymtxToken"),
            },
          }
        )
        .then((res) => {
          if (res.data.code == 2000) {
            console.log(res);
            this.mbti = res.data.data.mbti; //人格特性
            this.intelligent = res.data.data.intelligent; //智能水平
            this.hobby = res.data.data.hobby; //兴趣倾向
            this.profession = res.data.data.profession; //职业价值观
            this.mind = res.data.data.mind; //心里适应性
            this.result = res.data.data.mind.result;
            this.professionalRecommend = res.data.data.professionalRecommend;
            this.careerRecommend = res.data.data.careerRecommend;
            // this.appendix = res.data.data.appendix;

            this.getData();
            if (this.showPartb) {
              return;
            }
            this.targetCareerFieldZhuanye =
              this.professionalRecommend[0] &&
              this.professionalRecommend[0].name;
            this.tuijianDataZhuanye =
              this.professionalRecommend[0] &&
              this.professionalRecommend[0]["professionCode"];

            this.targetCareerFieldZhiye =
              this.careerRecommend[0] && this.careerRecommend[0].oneItem;
            this.tuijianDataZhiye =
              this.careerRecommend[0] &&
              this.careerRecommend[0]["twoItemValue"];
          } else {
          }
        });
    },
    changeFiled(value) {     
      this.careerMajorObj.targetSubject = [];
      this.careerMajorObj.targetCareer = [];
     
      this.careerData.forEach((item, index) => {
        if (item.name === value) {
          this.careerMajorObj.careerDataIndex = index;                    
        }
      });
    },
    selectChangeZhuanye(value) {
      this.tuijianDataZhuanye = this.careerMajorsZhuanye[value]["child"];
      this.careerMajorObj.professional = this.careerMajorsZhuanye[value].name;
      this.careerMajorObj.targetSubject = []
      
    },
    selectChangeZhiye(value) {
      
      this.tuijianDataZhiye = this.careerMajorsZhiye[value]["child"];
      this.careerMajorObj.targetCareerField=this.careerMajorsZhiye[value].name
      this.careerMajorObj.targetCareer = []

      
    },

    getCareerDataZhuanye() {
      this.$ajax
        .post(
          this.G_acapi + this.ports.consultant.student.report.zhuanyeData,
          {},
          {
            headers: {
              token: window.sessionStorage.getItem("ymtxToken"),
            },
          }
        )
        .then((res) => {
          if (res.data.code == 2000) {
          
            this.careerMajorsZhuanye = res.data.data;
            let bool;
            if (this.showPartb) {
              this.professionalRecommend.forEach((item, key) => {
                if (this.targetCareerFieldZhuanye == item.name) {
                  this.tuijianDataZhuanye = item.professionCode;
                  this.selectBoolZhuanye = false;
                  bool = false;
                }
              });
              if (bool) {
                this.careerMajorsZhuanye.forEach((item, key) => {
                  if (this.targetCareerFieldZhuanye == item.name) {
                    this.selectDataNumber = key;
                    this.targetCareerFieldZhuanye = "没有适合的专业";
                    this.tuijianDataZhuanye = item.child;
                  }
                });
              }
            }
          } else {
          }
        });
    },
    getCareerDataZhiye() {
      this.$ajax
        .post(
          this.G_acapi + this.ports.consultant.student.report.zhiyeData,
          {},
          {
            headers: {
              token: window.sessionStorage.getItem("ymtxToken"),
            },
          }
        )
        .then((res) => {
          if (res.data.code == 2000) {
            this.careerMajorsZhiye = res.data.data;
            let bool;
            if (this.showPartb) {
              this.careerRecommend.forEach((item, key) => {
                if (this.targetCareerFieldZhiye == item.name) {
                  this.tuijianDataZhiye = item.professionCode;
                  this.selectBoolZhiye = false;
                  bool = false;
                }
              });
              if (bool) {
                this.careerMajorsZhiye.forEach((item, key) => {
                  if (this.targetCareerFieldZhiye == item.name) {
                    this.selectDataNumber = key;
                    this.targetCareerFieldZhiye = "没有适合的职业";
                    this.tuijianDataZhiye = item.child;
                  }
                });
              }
            }
          } else {
          }
        });
    },
    radioChildZhuanye(number, item) {
      if (number == 4) {
        this.targetCareerFieldZhuanye = "没有适合的专业";
        this.selectBoolZhuanye = true;
      } else {
        this.targetCareerFieldZhuanye = item.name;
        this.tuijianDataZhuanye = item.professionCode;
        this.selectBoolZhuanye = false;
      }
      this.careerMajorObj.targetSubject = [];
      this.targetSubjectZhuanye = [];
    },
    radioChildZhiye(number, item) {
      if (number == 4) {
        this.targetCareerFieldZhiye = "没有适合的职业";
        this.selectBoolZhiye = true;
      } else {
        this.targetCareerFieldZhiye = item.oneItem;
        this.tuijianDataZhiye = item.twoItemValue;
        this.selectBoolZhiye = false;
      }
      // this.targetCareerZhiye = [];
      this.careerMajorObj.targetCareer = []
      this.targetSubjectZhiye = [];
    },
  },
  created() {
    this.getCareerMajor();
    
  },
  mounted() {
    this.getCareerDataZhuanye();
    this.getCareerDataZhiye();
    this.judgeNewOld()
  },
};
</script>
<style scoped lang="less">
.careerMajorList {
  padding: 26px 0;
  font-size: 16px;
  input {
    border: 1px solid #eaeaea;
    background-color: #fdfdfd;
  }
  .mainBox {
    margin-bottom: 30px;
    p {
      line-height: 26px;
      font-size: 16px;
      margin-bottom: 20px;
    }
  }
}
</style>
<style lang="less">
.careerMajorList {
  input {
    border: 1px solid #eaeaea;
  }
  .el-checkbox {
    width: 100%;
    margin-bottom: 20px;
    display: flex;
    align-items: flex-start;
    .el-checkbox__input {
      position: relative;
      top: 3px;
    }
  }
  .el-checkbox__label {
    color: #333;
    white-space: normal;
  }
}
</style>